export const circle = {

  /**
   * Calculate the area from the radius.
   * @param {Number} radius
   * @returns {number} area
   */
  calcArea(radius) {
    return radius * radius * Math.PI;
  },

  /**
   * Calculate the radius from the area.
   * @param {Number} area
   * @returns {number} radius
   */
  calcRadius(area) {
    return Math.sqrt(area / Math.PI);
  },
};